<p-accordion value="0">
  <p-accordion-panel value="0">
    <p-accordion-header>{{ title }}</p-accordion-header>
    <p-accordion-content>
      <div class="grid grid-cols-12 gap-4">
        <ng-content></ng-content>

        <div class="col-span-12 flex justify-end gap-2">
          <p-button label="Azzera" severity="secondary" icon="fa-solid fa-xmark" (onClick)="reset.emit()"></p-button>
          <p-button label="Ricerca" icon="fa-solid fa-magnifying-glass" (onClick)="search.emit()"></p-button>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
